import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Button, CircularProgress, Tooltip } from '@material-ui/core';

class FHEButton extends PureComponent {
    static propTypes = {
        loading: PropTypes.bool,
        disabled: PropTypes.bool,
        content: PropTypes.string.isRequired,
        tooltip: PropTypes.string,
        clickFunction: PropTypes.func.isRequired,
        fullWidth: PropTypes.bool,
        color: PropTypes.string,
        size: PropTypes.string,
        className: PropTypes.string,
        classes: PropTypes.object.isRequired
    };

    static defaultProps = {
        loading: false,
        disabled: false,
        fullWidth: true,
        color: 'primary',
        className: '',
        tooltip: null,
        size: 'medium'
    };

    render() {
        const { loading, content, clickFunction, fullWidth, color, className, size, disabled, classes, tooltip } = this.props;
        return (
            <div className={classes.container}>
                {tooltip ? (
                    <Tooltip title={tooltip} placement="top">
                        <div className={classes.container}>
                            <Button
                                className={`${classes.FHEButton} ${className}`}
                                fullWidth={fullWidth}
                                disabled={disabled || loading}
                                variant="contained"
                                color={color}
                                onClick={clickFunction}
                                size={size}
                            >
                                {!loading ? content : <CircularProgress color={color} size={20} />}
                            </Button>
                        </div>
                    </Tooltip>
                ) : (
                    <Button
                        className={`${classes.FHEButton} ${className}`}
                        fullWidth={fullWidth}
                        disabled={disabled || loading}
                        variant="contained"
                        color={color}
                        onClick={clickFunction}
                        size={size}
                    >
                        {!loading ? content : <CircularProgress color={color} size={20} />}
                    </Button>
                )}
            </div>
        );
    }
}

const styles = () => ({
    container: {
        width: '100%'
    },
    FHEButton: {
        margin: '10px 0'
    }
});

export default withStyles(styles, { withTheme: true })(FHEButton);



// WEBPACK FOOTER //
// ./data/components/FHEButton.js